import { render, staticRenderFns } from "./show-benefit-content.vue?vue&type=template&id=5569b497&scoped=true&"
import script from "./show-benefit-content.vue?vue&type=script&lang=js&"
export * from "./show-benefit-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5569b497",
  null
  
)

export default component.exports